
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1iydv_5",
  "variant-default": "awsui_variant-default_14iqq_1iydv_16",
  "variant-stacked": "awsui_variant-stacked_14iqq_1iydv_16",
  "header": "awsui_header_14iqq_1iydv_39",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1iydv_43",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1iydv_47",
  "header-stuck": "awsui_header-stuck_14iqq_1iydv_52",
  "with-divider": "awsui_with-divider_14iqq_1iydv_56",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1iydv_60",
  "with-paddings": "awsui_with-paddings_14iqq_1iydv_66",
  "content": "awsui_content_14iqq_1iydv_70",
  "footer": "awsui_footer_14iqq_1iydv_77"
};
  